import React, { useState, useEffect } from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import Button from 'CommonComponents/Button';
import SelectFromField from 'CommonComponents/SelectFromField';
import TextFormField from 'CommonComponents/TextFormField';

const EventsCreateSchema = Yup.object().shape({
    eventName: Yup.string().required('This value is required'),
    keyContactId: Yup.number().integer().positive().required(),
});

export default function EventsCreateForm(props) {
    const [users, setUsers] = useState([]);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        axios
            .get(props.organisationUsersUrl)
            .then((res) => {
                setUsers(res.data.users);
            })
            .catch((e) => {
                console.log(e);
            });
    }, []);

    return (
        <Formik
            initialValues={{
                eventName: '',
                keyContactId: '',
            }}
            validationSchema={EventsCreateSchema}
            onSubmit={(values, actions) => {
                let data = { ...values };
                axios
                    .post(props.storeEventUrl, data)
                    .then((response) => {
                        window.location.replace('/' + response.data.event.slug + '/event-setup?expand_set_up=1');
                    })
                    .catch((e) => {
                        actions.setErrors(e.response.data.errors);
                    })
                    .finally(() => {
                        actions.setSubmitting(false);
                    });
            }}
        >
            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue, setFieldTouched, initialValues }) => (
                <>
                    <div className={'tw-grid tw-grid-cols-12'}>
                        <div className={'tw-col-start-2 md:tw-col-start-4 tw-col-span-10 md:tw-col-span-6'}>
                            <div className="tw-grid tw-grid-cols-1 tw-gap-4">
                                <div className="table__card">
                                    <TextFormField
                                        label={$t('Project Name')}
                                        required={true}
                                        type="text"
                                        name="eventName"
                                        placeholder={$t('Project Name')}
                                    ></TextFormField>

                                    <div className={'mt-3'}>
                                        <SelectFromField label={$t('Project Admin')} required={true} as="select" name="keyContactId">
                                            <option value={''}>{$t('Select Admin')}</option>
                                            {users.map((user) => {
                                                return (
                                                    <option key={user.id} value={user.id}>
                                                        {user.first_name} {user.last_name}
                                                    </option>
                                                );
                                            })}
                                        </SelectFromField>
                                    </div>

                                    <div className={'tw-flex tw-justify-end mt-3'}>
                                        <Button variant="primary" disabled={isSubmitting} onClick={handleSubmit}>
                                            {$t('Submit')}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </Formik>
    );
}
